<template>
  <div class="case-box5">
    <a :href="cardInfo.link" target="_blank">
      <div class="content">
        <div class="line"></div>
        <span>{{ cardInfo.origin }}</span>
        <h1>{{ cardInfo.title }}</h1>
        <p>{{ cardInfo.text }}</p>
      </div>
      <img :src="cardInfo.imgSrc" alt="">
    </a>
  </div>
</template>

<script>
export default {
  props: ['cardInfo']
}
</script>

<style lang="scss" scoped>
@import '@/style/app.sass';

.case-box5 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 405px;
  padding: 21px;
  box-sizing: border-box;
  border: 1px solid $border-color1;
  border-radius: 3px;
  @include tablet {
    width: calc(33.333% - 20px);
  }
  @include mobile {
    width: 100%;
    margin-bottom: 24px;
  }
  &:hover {
    background-color: $primary2;
    & .content .line {
      background-color: #fff;
    }
    & .content h1,
    & .content span,
    & .content p {
      color: #fff;
    }
  }
  .content {
    margin-bottom: 60px;
    .line {
      height: 2px;
      background-color: $primary1;
      margin-bottom: 20px;
    }
    >span {
      margin-bottom: 7px;
      line-height: 1;
      color: $font-color2;
      font-size: 12px;
      font-weight: 500;
    }
    >h1 {
      color: $font-color1;
      font-size: $fontSize20;
      font-weight: 500;
      line-height: 27px;
      margin-bottom: 12px;
    }
    >p {
      color: $font-color2;
      line-height: 24px;
      font-size: $fontSize16;
      font-weight: 400;
    }
  }
  & img {
    width: 100%;
    max-height: 204px;
    @include mobile {
      width: 100%;
    }
  }
}
</style>
